export enum MainMenuApp {
    REPORTING = 'Reporting',
    FAST_PROVISIONING = 'FastProvisioning',
    ADMIN = 'Admin',
    STATUS = 'Status'
}
